import React from 'react';

const TestPage = () => {
  return (
    <div>
      <iframe src="/explore_schools?embed=true" width="100%" height="600px" title="Explore Page"></iframe>

    </div>
  );
};

export default TestPage;
